module.exports = __webpack_public_path__ + "static/media/walltittle.1b0ea58a.jpeg";